import { REACT_APP_VMS_BASE_URL } from "../utils/urls";

const createVehicle = async (data: any) => {
  const result = await fetch(`${REACT_APP_VMS_BASE_URL}/vehicles`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });
  const contacts = await result.json();
  return contacts;
};

export default createVehicle;
